import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import { USER } from "./reducers/user";
import { POSTS } from "./reducers/post";
import { SEARCH_USERS } from "./reducers/searchUsers";

export const ConfigureStore = () => {
    const store = createStore(
        combineReducers({
            user: USER, posts: POSTS, searchUsers: SEARCH_USERS
        }),
        applyMiddleware(thunk)
    );

    return store;
}